import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import { withRouter } from "react-router-dom";
import CardRequestView from "./components/ViewCardRequest";
import PageHeader from "../../../shared/components/PageHeader";
import { getCardRequest, retryFailed, sendSuccessCards, resetCardRequest } from "../actions/cardrequests.actions";

const ViewCardRequest = (props) => {
    const { dispatch, cardRequest, retryRequest, sendSucessfulCardOnly, history } = props;
    const [showRetryButton, setShowRetryButton] = useState(false);
    const [showSendSucesssFulButton, setShowSendSucesssFulButton] = useState(false);
    const [showResendButton, setShowResendButton] = useState(false);
    function fetchCardRequest() {
        dispatch(getCardRequest(props.match.params.id));
    }

    function retryBulk() {
        try {
            if (cardRequest && cardRequest.response && cardRequest.response.id) {
            
                if (showResendButton) {
                    
                    dispatch(retryFailed(cardRequest.response.id, "resend", history));
                } else {
                    dispatch(retryFailed(cardRequest.response.id, "retry", history));
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    function sendSuccesfulCardsActions() {
        try {
            if (cardRequest && cardRequest.response && cardRequest.response.batchId) {
              

                dispatch(sendSuccessCards(cardRequest.response.batchId, "complete"));
            }
        } catch (err) {
            console.error(err);
        }
    }
    const resetCardStatus = () => {
        dispatch(resetCardRequest());
       
    };

    useEffect(() => {
        return () => {
          
            setShowRetryButton(false);
            setShowSendSucesssFulButton(false);
            setShowResendButton(false);
            resetCardStatus();
        };
    }, []);

    useEffect(() => {
        if (props.match.params.id) {
            dispatch(getCardRequest(props.match.params.id));
        }
    }, [dispatch, props.match.params.id]);

    useEffect(() => {
      

        if (cardRequest && cardRequest.response) {
            
            if (cardRequest.success) {
          
                if ((cardRequest.response.autoUploadStatus === "REQUEST_PRODUCTION_FAILED" && cardRequest.response.status === "FAILED") || (cardRequest.response.autoUploadStatus === null && cardRequest.response.status === "PENDING")) {
                    setShowRetryButton(true);
                    setShowResendButton(false);
                    
                }
                if (cardRequest.response.autoUploadStatus === "REQUEST_PRODUCTION_FAILED" && cardRequest.response.status === "FAILED") {
                    setShowSendSucesssFulButton(true);
                }
                if ((cardRequest.response.autoUploadStatus === "REQUEST_PERSONALIZATION_FAILED" || cardRequest.response.autoUploadStatus === "REQUEST_VALIDATION_FAILED") && cardRequest.response.status === "FAILED") {
                    setShowRetryButton(false);
                    setShowResendButton(true);
                    setShowSendSucesssFulButton(false);
                   
                }
            }
        }
    }, [cardRequest && cardRequest.success]);

    return (
        <Container>
            <PageHeader header="View Card Request" subheader="View card request details" />
            <Row>
                <CardRequestView
                    cardRequestId={props.match.params.id}
                    cardRequest={cardRequest}
                    fetchData={fetchCardRequest}
                    retryBulk={retryBulk}
                    retryRequest={retryRequest}
                    completedBatch={sendSuccesfulCardsActions}
                    sendSucessfulCardOnly={sendSucessfulCardOnly}
                    showRetryButton={showRetryButton}
                    showSendSucesssFulButton={showSendSucesssFulButton}
                    showResendButton={showResendButton}
                />
            </Row>
        </Container>
    );
};

export default connect((state) => ({
    cardRequest: state.getCardRequest,
    retryRequest: state.retryCardRequestReducer,
    sendSucessfulCardOnly: state.sendSuccessCardsReducer,
}))(withRouter(ViewCardRequest));
